import { render, staticRenderFns } from "./VDataTableQuotes.vue?vue&type=template&id=659d111d&scoped=true"
import script from "./VDataTableQuotes.vue?vue&type=script&lang=js"
export * from "./VDataTableQuotes.vue?vue&type=script&lang=js"
import style0 from "./VDataTableQuotes.vue?vue&type=style&index=0&id=659d111d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d111d",
  null
  
)

export default component.exports